import { SxProps, Theme } from "@mui/material";

export const KPI_TILE_MIN_WIDTH = 160;

export const KPI_STRIP_ROOT_SX: SxProps<Theme> = {
    width: "100%",
    boxSizing: "border-box",
    mb: 4,
};

export const KPI_CONTROLS_SX: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 2,
    mb: 2,
};

export const KPI_CONTROLS_LABEL_SX: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    gap: 1,
};

export const KPI_TOGGLE_WRAPPER_SX: SxProps<Theme> = {
    width: (theme) => theme.spacing(36),
    maxWidth: "100%",
};

export const KPI_TILES_SX: SxProps<Theme> = {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    alignItems: "stretch",
    boxSizing: "border-box",
    gap: 2,
};

export const KPI_TILE_WRAPPER_SX: SxProps<Theme> = {
    display: "flex",
    flex: "1 1 0",
    minWidth: KPI_TILE_MIN_WIDTH,
};

export const KPI_STAT_CARD_SX: SxProps<Theme> = {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    p: 3,
    borderRadius: (theme) => theme.spacing(4),
    boxShadow: (theme) => theme.shadows[2],
};

export const KPI_LABEL_SX: SxProps<Theme> = {
    color: "text.secondary",
    letterSpacing: (theme) => theme.typography.overline.letterSpacing,
};

export const KPI_VALUE_SX: SxProps<Theme> = {
    color: "primary.main",
    mt: 1,
};

export const KPI_VALUE_SKELETON_SX: SxProps<Theme> = {
    width: "60%",
    borderRadius: (theme) => theme.shape.borderRadius,
    fontSize: (theme) => theme.typography.h3.fontSize,
    mt: 1,
};

export const KPI_CAPTION_SX: SxProps<Theme> = {
    color: "text.secondary",
    marginTop: "auto",
    pt: 2,
};

export const KPI_ERROR_SX: SxProps<Theme> = {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
};
